//Please add the language resource
const interfaceLog = {
  orderNo:'订单编号',
  msg:{
  }
};
export default interfaceLog



// WEBPACK FOOTER //
// ./src/page/log/interfaceLog/lang/interfaceLog.en.js